import React, { Component, PropTypes } from 'react';
import Icon from '../../tc-ui/icon';

class LeftBarDetail extends Component {

  render() {
    const {
      title,
      infoToDisplay,
      isEditable,
      classification,
      noMargin,
      infoArray,
      itemName,
      inline,
      editField,
    } = this.props;

    let edit;
    let detailToDisplay;
    let noInfoToDisplay;

    if (infoToDisplay !== undefined) {
      detailToDisplay = infoToDisplay;
    } if (title === 'Destinations Sold' && infoArray.some(destination => destination === 'All')) {
      detailToDisplay = 'All';
    } else if (infoArray && infoArray.length) {
      detailToDisplay = (
        <ul style={{ 'listStyle': 'none' }}>
          {infoArray.map((info, index) => <li key={index}>{info}</li>)}
        </ul>
      );
    }

    if (isEditable) {
      if (!detailToDisplay && detailToDisplay !== 0) {
        noInfoToDisplay = true;
        detailToDisplay = (
          <div onClick={editField} className="description-segments-add">
            <Icon className="tc-icon-add description-segments-add-icon"/><span className="description-segments-add-label">Add {itemName}</span>
          </div>
        );
      } else {
        edit = (
          <span onClick={editField} className="description-segments-edit">
            <Icon style={{ fontSize: '14px', marginRight: '4px' }} className="tc-icon-mode_edit"/>
            Edit
          </span>
        );
      }
    }

    const header = inline ? undefined : (
      <div className="description-segments">
        <span style={this.props.headerStyle} className="description-segments-title">
          {title}
        </span>
        {edit}
      </div>
    );

    const inlineNodeStyle = {
      fontSize: '24px',
      fontWeight: '600',
      display: 'inline-block',
      marginRight: '8px',
    };
    if (itemName === 'Interconnecting Rooms') {
      detailToDisplay = (() => {
        if (infoToDisplay) return 'INTERCONNECTING ROOMS AVAILABLE';
        if (infoToDisplay === false && isEditable) return 'NO INTERCONNECTING ROOMS';
      })();
      inlineNodeStyle.fontSize = '14px';
      inlineNodeStyle.fontWeight = '400';
    }

    const margin1 = noMargin ? undefined : { marginTop: '16px' };
    const margin2 = noMargin ? undefined : { marginTop: '32px' };

    const information = inline ? (
      <div style={margin1}>
        <div style={inlineNodeStyle}>
          {detailToDisplay}
        </div>
        {classification && !noInfoToDisplay ? classification.toUpperCase() : undefined}
        {edit}
      </div>
    ) : (
      <div className="l-paper-split-segment" style={{ maxHeight: '300px', overflowY: 'scroll' }}>
        {detailToDisplay}
      </div>
    );

    if (!detailToDisplay && !isEditable) return false;
    return (
      <div style={margin2}>
        {header}
        {information}
      </div>
    );
  }
}

LeftBarDetail.propTypes = {
  title: PropTypes.string,
  infoToDisplay: PropTypes.any,
  isEditable: PropTypes.bool,
  classification: PropTypes.string,
  noMargin: PropTypes.bool,
  infoArray: PropTypes.array,
  itemName: PropTypes.string,
  inline: PropTypes.bool,
  editField: PropTypes.func,
};

export default LeftBarDetail;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/left-bar-detail.jsx